<template>
  <div class="wrapper-callback">
    <div class="spinner">
      <img src="../assets/loading.svg" alt="loading"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'callback',
  methods: {
    ...mapActions('session', ['handleAuthentication', 'getUserInfo'])
  },
  beforeMount () {
    this.handleAuthentication()
      .then(() => {
        this.$router.replace('/')
        this.getUserInfo()
      }).catch(error => {
        console.log(error)
        this.$router.push({ name: 'login' })
      })
    return {}
  }
}
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
